module.exports = __webpack_public_path__ + "assets/img/2063.a9cf44e6.svg";